import { BASE_URL, ENDPOINT_URL } from "../../config/urlConfig";
import { ApiService } from "../../config/apiServices";

export const UserHeartBeatApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.user_heartbeat?.userheartbeat;
  return ApiService.post(METHOD_URL, data);
}